export const getStatusColor = (status) => {
    const s = typeof status === 'string' ? status.toLowerCase() : '';
    switch (s) {
        case 'published':
            return { bgcolor: '#E8F5E8', color: '#2E7D32' };
        case 'draft':
            return { bgcolor: '#FFF3E0', color: '#F57C00' };
        case 'archived':
            return { bgcolor: '#FFEBEE', color: '#C62828' };
        default:
            return { bgcolor: '#F5F5F5', color: '#666' };
    }
};

export const getEventTypeColor = (eventType) => {
    const e = typeof eventType === 'string' ? eventType.toLowerCase() : '';
    switch (e) {
        case 'training':
            return { bgcolor: '#E3F2FD', color: '#1976D2' };
        case 'workshop':
            return { bgcolor: '#F3E5F5', color: '#7B1FA2' };
        case 'retreat':
            return { bgcolor: '#E8F5E8', color: '#2E7D32' };
        default:
            return { bgcolor: '#F5F5F5', color: '#666' };
    }
};

export const getExperienceColor = (experience) => {
    const e = typeof experience === 'string' ? experience.toLowerCase() : '';
    switch (e) {
        case 'beginner':
            return { bgcolor: '#E8F5E8', color: '#2E7D32' };
        case 'intermediate':
            return { bgcolor: '#FFF3E0', color: '#F57C00' };
        case 'advanced':
            return { bgcolor: '#FFEBEE', color: '#C62828' };
        default:
            return { bgcolor: '#F5F5F5', color: '#666' };
    }
};
